import React from 'react';
import appShowcase01 from '../../../assets/images/technology/app-showcase-01.jpg';
import appShowcase01Mobile from '../../../assets/images/technology/app-showcase-01-sm.jpg';
import appShowcase02 from '../../../assets/images/technology/app-showcase-02.jpg';
import appShowcase02Mobile from '../../../assets/images/technology/app-showcase-02-sm.jpg';
import appShowcase03 from '../../../assets/images/technology/app-showcase-03.jpg';
import appShowcase03Mobile from '../../../assets/images/technology/app-showcase-03-sm.jpg';
import appShowcase04 from '../../../assets/images/technology/app-showcase-04.jpg';
import appShowcase04Mobile from '../../../assets/images/technology/app-showcase-04-sm.jpg';
import appShowcase05 from '../../../assets/images/technology/app-showcase-05.jpg';
import appShowcase05Mobile from '../../../assets/images/technology/app-showcase-05-sm.jpg';

export const carouselStatic = [
  {
    backgroundType: 'light',
    image: {
      src: appShowcase01,
      srcMobile: appShowcase01Mobile,
      alt: 'Mila quiets down when you’re around. - showcase',
      width: 1440,
      height: 812,
      widthMobile: 390,
      heightMobile: 712,
    },
    title: 'Mila quiets down when you’re around.',
    description: () => (
      <p>
        Mila is the first purifier to detect presence in the room and deep clean
        when you aren’t around—increasing cleaning power in your home by 40%.
        more effective cleaning power.
      </p>
    ),
  },
  {
    backgroundType: 'light',
    image: {
      src: appShowcase02,
      srcMobile: appShowcase02Mobile,
      alt: 'And becomes your stealth housekeeper by day. - showcase',
      width: 1440,
      height: 812,
      widthMobile: 390,
      heightMobile: 659,
    },
    title: 'And becomes your stealth housekeeper by day.',
    description: () => (
      <p>
        Mila is the first purifier to detect presence in the room and deep clean
        when you aren’t around—increasing cleaning power in your home by 40%.
        more effective cleaning power.
      </p>
    ),
  },
  {
    backgroundType: 'dark',
    image: {
      src: appShowcase03,
      srcMobile: appShowcase03Mobile,
      alt: 'She prepares the bedroom before bedtime - showcase',
      width: 1440,
      height: 812,
      widthMobile: 390,
      heightMobile: 620,
    },
    title: 'She prepares the bedroom before bedtime.',
    description: () => (
      <p>
        Mila is the first purifier to detect presence in the room and deep clean
        when you aren’t around—increasing cleaning power in your home by 40%.
        more effective cleaning power.
      </p>
    ),
  },
  {
    backgroundType: 'dark',
    image: {
      src: appShowcase04,
      srcMobile: appShowcase04Mobile,
      alt: 'And lulls to sleep with whitenoise... - showcase',
      width: 1440,
      height: 812,
      widthMobile: 390,
      heightMobile: 620,
    },
    title: 'And lulls to sleep with whitenoise...',
    description: () => (
      <p>
        Mila is the first purifier to detect presence in the room and deep clean
        when you aren’t around—increasing cleaning power in your home by 40%.
        more effective cleaning power.
      </p>
    ),
  },
  {
    backgroundType: 'dark',
    image: {
      src: appShowcase05,
      srcMobile: appShowcase05Mobile,
      alt: 'Or quietly watches over you.... - showcase',
      width: 1440,
      height: 812,
      widthMobile: 390,
      heightMobile: 621,
    },
    title: 'Or quietly watches over you...',
    description: () => (
      <p>Mila knows some people want total quiet when ur sleeping</p>
    ),
  },
];
